export const TABLE_SCALE_DEFAULT = 'normal'
export const TABLE_SCALE_MODES = ['compact', 'normal', 'comfortable', 'large']

const TABLE_SCALE_STYLES = {
  compact: { '--table-cell-font-size': '11px', '--table-cell-height': '24px', '--table-cell-padding-y': '2px', '--table-cell-padding-x': '4px', '--table-cell-line-height': '1.15' },
  normal: { '--table-cell-font-size': '13px', '--table-cell-height': '30px', '--table-cell-padding-y': '5px', '--table-cell-padding-x': '6px', '--table-cell-line-height': '1.2' },
  comfortable: { '--table-cell-font-size': '14px', '--table-cell-height': '38px', '--table-cell-padding-y': '8px', '--table-cell-padding-x': '8px', '--table-cell-line-height': '1.3' },
  large: { '--table-cell-font-size': '16px', '--table-cell-height': '48px', '--table-cell-padding-y': '11px', '--table-cell-padding-x': '12px', '--table-cell-line-height': '1.4' },
}

export function normalizeTableScale(value) {
  return TABLE_SCALE_MODES.includes(value) ? value : TABLE_SCALE_DEFAULT
}

export function getBrowserStorage() {
  try {
    return typeof window === 'undefined' ? undefined : window.localStorage
  } catch {
    return undefined
  }
}

export function tableScaleStorageKey(userId, tableId) {
  return `erpTableScale:v1:${String(userId)}:${String(tableId)}`
}

export function loadTableScale(storage, userId, tableId) {
  if (userId === null || userId === undefined || userId === '') return TABLE_SCALE_DEFAULT
  try {
    return normalizeTableScale(storage?.getItem(tableScaleStorageKey(userId, tableId)))
  } catch {
    return TABLE_SCALE_DEFAULT
  }
}

export function saveTableScale(storage, userId, tableId, value) {
  const normalized = normalizeTableScale(value)
  if (userId === null || userId === undefined || userId === '') return normalized
  try {
    storage?.setItem(tableScaleStorageKey(userId, tableId), normalized)
  } catch {
    return normalized
  }
  return normalized
}

export function tableScaleStyle(value) {
  return TABLE_SCALE_STYLES[normalizeTableScale(value)]
}
